<template>
  <div class="layout">
    <Header />
    <main class="main">
      <router-view />
    </main>
    <Footer />

    <!-- 桌面悬浮咨询按钮 · 玫瑰粉柔光 -->
    <button
      class="float-cta"
      @click="showContactPopup = true"
      aria-label="联系咨询"
    >
      <span class="fc-glow"></span>
      <span class="fc-inner">
        <i class="fas fa-comment-dots" style="font-size: 24px;"></i>
      </span>
      <span class="fc-label">留言咨询</span>
    </button>

    <!-- 移动端底部 sticky action bar -->
    <nav class="mob-actionbar" aria-label="快速联系">
      <a href="tel:19927640438" class="mab-item mab-phone">
        <i class="fas fa-phone-alt"></i>
        <span>电话</span>
      </a>
      <button class="mab-item mab-wechat" @click="copyPhone">
        <i class="fab fa-weixin"></i>
        <span>微信</span>
      </button>
      <button class="mab-item mab-consult" @click="showContactPopup = true">
        <span>留言咨询</span>
      </button>
    </nav>

    <!-- 联系弹窗 · 柔光风 -->
    <transition name="popup">
      <div
        v-if="showContactPopup"
        class="popup-overlay"
        @click="showContactPopup = false"
      >
        <article class="popup" @click.stop>
          <span class="popup-orb popup-orb-rose"></span>
          <span class="popup-orb popup-orb-lavender"></span>

          <header class="popup-head">
            <div class="popup-title-block">
              <p class="popup-hand font-hand">来 聊 一 聊 吧</p>
              <h3 class="popup-title">联 系 我 们</h3>
            </div>
            <button class="popup-close" @click="showContactPopup = false" aria-label="关闭">
              <i class="fas fa-times"></i>
            </button>
          </header>

          <div class="popup-body">
            <a href="tel:19927640438" class="popup-phone">
              <span class="pp-label font-hand">随时拨打</span>
              <span class="pp-num">199 2764 0438</span>
              <span class="pp-arrow">→</span>
            </a>

            <div class="popup-divider">
              <span class="font-hand">— 或 留 言 —</span>
            </div>

            <form class="popup-form" @submit.prevent="submitForm">
              <input v-model="form.name" type="text" placeholder="你的名字" maxlength="40" class="pf-input"/>
              <input v-model="form.phone" type="tel" placeholder="联系电话" maxlength="40" class="pf-input"/>
              <textarea v-model="form.message" placeholder="说说你的情况，我们认真看" maxlength="1500" rows="4" class="pf-input"></textarea>
              <button class="btn btn-rose popup-submit" :disabled="submitting" type="submit">
                <span>{{ submitting ? "正在提交…" : "提交留言" }}</span>
                <span class="btn-arrow">→</span>
              </button>
            </form>

            <p class="popup-foot font-hand">不 着 急 · 慢 慢 来</p>
          </div>
        </article>
      </div>
    </transition>

    <!-- 全局视频弹窗 · 通过 $root.$emit('open-video', src) 触发
         必须放在 layout 层而不是子页面，否则会被 .main 的 stacking context 限制 -->
    <transition name="vmodal">
      <div v-if="showVideoModal" class="video-modal" @click="closeVideo">
        <div class="video-modal-inner" @click.stop>
          <button class="video-modal-close" @click="closeVideo" aria-label="关闭">
            <i class="fas fa-times"></i>
          </button>
          <video controls autoplay ref="videoPlayer" :src="currentVideoSrc">
            您的浏览器不支持视频播放
          </video>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Header from "./Header.vue";
import Footer from "./Footer.vue";
import axios from "axios";

export default {
  name: "Layout",
  components: { Header, Footer },
  data() {
    return {
      showContactPopup: false,
      submitting: false,
      form: { name: "", phone: "", message: "" },
      /* 全局视频弹窗状态 */
      showVideoModal: false,
      currentVideoSrc: ""
    };
  },
  mounted() {
    this.$root.$on("open-contact-popup", () => {
      this.showContactPopup = true;
    });
    /* 子页面通过 $root.$emit('open-video', src) 打开视频 */
    this.$root.$on("open-video", (src) => {
      this.currentVideoSrc = src;
      this.showVideoModal = true;
    });
  },
  methods: {
    closeVideo() {
      this.showVideoModal = false;
      /* 暂停播放释放资源 */
      this.$nextTick(() => {
        const v = this.$refs.videoPlayer;
        if (v && typeof v.pause === "function") v.pause();
      });
      /* 清空 src 让下次打开时干净 */
      setTimeout(() => { this.currentVideoSrc = ""; }, 350);
    },
    copyPhone() {
      if (navigator.clipboard) {
        navigator.clipboard.writeText("19927640438")
          .then(() => this.$message.success("微信号已复制"))
          .catch(() => this.fallback());
      } else this.fallback();
    },
    fallback() {
      const ta = document.createElement("textarea");
      ta.value = "19927640438";
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand("copy"); this.$message.success("微信号已复制"); }
      catch { this.$message.error("复制失败"); }
      document.body.removeChild(ta);
    },
    async submitForm() {
      if (!this.form.name || !this.form.phone || !this.form.message) {
        this.$message.warning("请填写完整信息");
        return;
      }
      if (this.submitting) return;
      this.submitting = true;
      try {
        const params = new URLSearchParams();
        params.append("real_name", this.form.name);
        params.append("phone", this.form.phone);
        params.append("remark", this.form.message);
        params.append("serve", "其他");
        const response = await axios.post(
          "https://yc.sll81.com/wuxiu/heal/websiteConsult/wechat/mini/save",
          params
        );
        if (response.data.result_code === "SUCCESS") {
          this.$message.success("预约成功，我们会尽快联系你！");
          this.form = { name: "", phone: "", message: "" };
          this.showContactPopup = false;
        } else {
          this.$message.error(response.data.result_msg || "提交失败");
        }
      } catch (e) {
        console.error(e);
        this.$message.error("提交失败，请稍后重试");
      } finally {
        this.submitting = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.main {
  padding-top: var(--header-offset, 78px);
  min-height: calc(100vh - 280px);
  min-height: calc(100dvh - 280px);
  position: relative;
  z-index: 2;
}

/* ============================================
   桌面悬浮咨询按钮 · 柔光球+按钮
   ============================================ */
.float-cta {
  position: fixed;
  right: 32px;
  bottom: 32px;
  width: 132px;
  height: 132px;
  z-index: 900;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  &:hover {
    transform: translateY(-4px) rotate(-3deg);
    .fc-glow { transform: scale(1.15); opacity: 0.85; }
    .fc-inner { background: var(--rose-d); }
  }
  .fc-glow {
    position: absolute;
    inset: 0;
    border-radius: 50%;
    background: radial-gradient(circle, var(--rose) 0%, transparent 70%);
    filter: blur(20px);
    opacity: 0.7;
    transition: transform 0.6s ease, opacity 0.4s;
  }
  .fc-inner {
    position: relative;
    width: 64px;
    height: 64px;
    background: var(--rose);
    color: var(--milk);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 12px 28px -8px rgba(232, 165, 148, 0.65);
    transition: background 0.3s;
  }
  .fc-label {
    position: absolute;
    bottom: 12px;
    left: 50%;
    transform: translateX(-50%);
    font-family: var(--font-hand);
    font-size: 16px;
    color: var(--ink);
    background: var(--milk);
    padding: 3px 12px;
    border-radius: 999px;
    box-shadow: var(--shadow-soft);
    white-space: nowrap;
    pointer-events: none;
  }
}

/* ============================================
   移动端底部 sticky action bar
   ============================================ */
.mob-actionbar {
  display: none;
  position: fixed;
  left: 12px;
  right: 12px;
  bottom: 12px;
  z-index: 950;
  background: var(--vellum);
  border-radius: 999px;
  padding: 6px;
  box-shadow: 0 12px 32px -8px rgba(58, 46, 37, 0.25);
  border: 1px solid var(--line);
}
.mab-item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px 12px;
  background: transparent;
  color: var(--ink-2);
  font-family: var(--font-body);
  font-size: 12.5px;
  font-weight: 500;
  border-radius: 999px;
  transition: background 0.25s, color 0.25s;
  &:hover { background: var(--paper-2); }
}
.mab-phone, .mab-wechat { color: var(--sage-d); }
.mab-consult {
  flex: 1.6;
  background: var(--rose);
  color: var(--milk);
  font-family: var(--font-body);
  font-weight: 600;
  &:hover { background: var(--rose-d); }
}

/* ============================================
   弹窗
   ============================================ */
.popup-overlay {
  position: fixed;
  inset: 0;
  background: rgba(58, 46, 37, 0.55);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 20px;
}
.popup {
  position: relative;
  width: 100%;
  max-width: 460px;
  max-height: 92vh;
  /* 关键：容器自身禁止滚动，剪掉柔光球溢出 */
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: var(--vellum);
  border-radius: 28px;
  box-shadow: 0 32px 64px -12px rgba(58, 46, 37, 0.3);
}
.popup-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(50px);
  opacity: 0.55;
  pointer-events: none;
  z-index: 0;
}
.popup-orb-rose {
  width: 200px; height: 200px;
  background: radial-gradient(circle, var(--rose) 0%, transparent 70%);
  top: -60px; right: -40px;
}
.popup-orb-lavender {
  width: 180px; height: 180px;
  background: radial-gradient(circle, var(--lavender) 0%, transparent 70%);
  bottom: -40px; left: -30px;
}

.popup-head {
  position: relative;
  z-index: 2;
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 28px 28px 14px;
}
.popup-hand {
  font-size: 20px;
  color: var(--rose-d);
  margin-bottom: 4px;
}
.popup-title {
  font-family: var(--font-cn);
  font-weight: 500;
  font-size: 26px;
  letter-spacing: 0.2em;
  color: var(--ink);
}
.popup-close {
  width: 34px; height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--paper);
  border-radius: 50%;
  color: var(--ink-2);
  transition: background 0.25s, transform 0.25s;
  &:hover { background: var(--ink); color: var(--milk); transform: rotate(90deg); }
}

.popup-body {
  position: relative;
  z-index: 2;
  /* 仅内部 body 可滚动 */
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 14px 28px 28px;
}

.popup-phone {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px 22px;
  background: var(--sage);
  color: var(--milk);
  border-radius: 18px;
  margin-bottom: 22px;
  transform: rotate(-1deg);
  transition: transform 0.3s, background 0.3s;
  &:hover { transform: rotate(0); background: var(--sage-d); }
  .pp-label {
    font-size: 14px;
    color: var(--honey-pale);
  }
  .pp-num {
    flex: 1;
    font-family: var(--font-display);
    font-weight: 500;
    font-size: 22px;
    letter-spacing: 0.04em;
    text-align: right;
  }
  .pp-arrow {
    font-family: var(--font-display);
    font-size: 20px;
    color: var(--honey-pale);
    transition: transform 0.3s;
  }
  &:hover .pp-arrow { transform: translateX(4px); }
}

.popup-divider {
  text-align: center;
  margin: 18px 0 14px;
  .font-hand { font-size: 16px; color: var(--ink-4); }
}

.popup-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.pf-input {
  width: 100%;
  padding: 14px 16px;
  background: var(--paper);
  border: 1px solid transparent;
  border-radius: 14px;
  font-family: var(--font-body);
  font-size: 14px;
  color: var(--ink);
  transition: border-color 0.25s, background 0.25s;
  &::placeholder { color: var(--ink-4); }
  &:focus { border-color: var(--rose); background: var(--milk); }
}
textarea.pf-input { resize: vertical; min-height: 90px; line-height: 1.7; }
.popup-submit {
  width: 100%;
  margin-top: 4px;
}

.popup-foot {
  text-align: center;
  margin-top: 16px;
  font-size: 15px;
  color: var(--ink-4);
}

.popup-enter-active, .popup-leave-active {
  transition: opacity 0.35s;
  .popup { transition: transform 0.5s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.35s; }
}
.popup-enter, .popup-leave-to {
  opacity: 0;
  .popup { transform: translateY(20px) scale(0.96); opacity: 0; }
}

/* ============================================
   全局视频弹窗 · z-index 3000 在 layout 层不受子页面 stacking 限制
   ============================================ */
.video-modal {
  position: fixed;
  inset: 0;
  background: rgba(58, 46, 37, 0.85);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
  padding: 20px;
}
.video-modal-inner {
  position: relative;
  width: 100%;
  max-width: 900px;
  border-radius: 24px;
  overflow: hidden;
  background: var(--ink);
  box-shadow: 0 24px 60px -16px rgba(0, 0, 0, 0.5);
  video {
    width: 100%;
    display: block;
    max-height: 80vh;
  }
}
.video-modal-close {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(250, 243, 232, 0.2);
  color: var(--milk);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  transition: background 0.25s, transform 0.25s;
  &:hover { background: var(--rose); transform: rotate(90deg); }
}
.vmodal-enter-active, .vmodal-leave-active {
  transition: opacity 0.35s;
  .video-modal-inner {
    transition: transform 0.5s cubic-bezier(0.16, 1, 0.3, 1);
  }
}
.vmodal-enter, .vmodal-leave-to {
  opacity: 0;
  .video-modal-inner { transform: scale(0.92); }
}

@media (max-width: 768px) {
  .main {
    padding-top: var(--header-offset, 64px);
    padding-bottom: 80px;
  }
  .float-cta { display: none; }
  .mob-actionbar { display: flex; gap: 4px; }
  .popup-overlay { align-items: flex-end; padding: 0; }
  .popup {
    max-width: 100%;
    border-radius: 28px 28px 0 0;
    max-height: 88vh;
  }
}
</style>
